// @flow
import Checkbox from 'react-bootstrap/lib/Checkbox';
import type { FacetOption as FacetOptionType } from '../../types/FacetOption';
import React from 'react';
import styles from './ToggleStyles.module.scss';
import Text from '@liveauctioneers/caterwaul-components/lib/Text/Text';

type Props = {
    onChange: Function,
    option: FacetOptionType,
};

const CheckboxFacet = (props: Props) => {
    const { onChange, option } = props;

    return (
        <div className={styles.toggleOption}>
            <Checkbox
                checked={option.selected}
                className={styles.toggler}
                disabled={option.count === 0}
                name={option.id}
                onChange={onChange}
                value={option.id}
            >
                <Text secondary className={styles.optionName}>
                    {option.name}
                    {!isNaN(option.count) && (
                        <Text caption className={styles.optionResultsCount}>
                            <span> ({Number(option.count).toLocaleString()})</span>
                        </Text>
                    )}
                </Text>
            </Checkbox>
        </div>
    );
};

export default React.memo<Props>(CheckboxFacet);
